// This "selector" ignores the redux state and returns the query string portion of the URL.
// Note that it returns the "real" query string, not the one in the hash/fragment.
// This selector exists so that it can be given as an input to createSelector,
// so that memoization works correctly.
// In normal usage, the query string never changes after the initial page load,
// so it doesn't matter that the query string updates aren't concurrent with Redux updates.
export const queryStringSelector = () => window.location.search;